import { graphql } from 'gatsby'
import isNil from 'lodash/isNil'
import React from 'react'

import Persons from '@/components/persons/persons'
const FeaturedPersons: React.FC<Queries.FeaturedPersonFragment> = ({
  person,
  title,
  isDark
}) => {
  if (isNil(person)) return null
  if (isNil(title)) return null
  return <Persons persons={person} title={title} isDark={isDark === true} />
}

export default FeaturedPersons

export const query = graphql`
  fragment FeaturedPerson on DatoCmsFeaturedPerson {
    __typename
    id
    title
    navigationLabel
    isDark
    person {
      ...PersonDetail
    }
  }
`
